<template>
  <div class="map-container">
    <div class="map map-google-container" >
      <GoogleMap class="map-google" api-key="AIzaSyCCIJOC3Yi7HxmdOWsX37zug30tVWV7W-g" :center="center" :zoom="17">
        <Marker :options="{ position: center }" />
      </GoogleMap>
    </div>
   
            <div class="map-content-card" >
              <div>
                <h2>Location</h2>
                <p>The LEED summer conference will be held in the triple-accredited business school of Manchester Metropolitan University.</p>
                <p><b>Find us at: <br>Business School, Manchester, M15 6BH</b></p>
              </div>
            </div>
            <div class="map-content-img" id="location">
              <!-- <img src="../assets/business-school.jpg" alt=""> -->
            </div>
          </div>
 
</template>

<script setup>
import { defineComponent } from "vue"
import { GoogleMap, Marker } from "vue3-google-map"
import Nav from '../components/Nav.vue'
import Hero from '../components/Hero.vue'
import About from '../components/About.vue'

    // const APIKey = process.env.VUE_APP_API_KEY
    
    const center = { lat: 53.47024599832844, lng:-2.2402742205012567 }

</script>